//action types
export const GET_CONVERSATION_LIST = 'GET_CONVERSATION_LIST';
export const GET_CONVERSATION_MESSAGE_HISOTRY = 'GET_CONVERSATION_MESSAGE_HISOTRY';
export const SEND_MESSAGE = 'SEND_SMS';
export const UPDATE_MESSAGE_STATUS = 'UPDATE_MESSAGE_STATUS';
export const SEND_MESSAGE_FAILED = 'SEND_MESSAGE_FAILED';
export const INITIATE_CONVERSATION = "INITIATE_CONVERSATION";
export const HANDLE_INCOMING_MESSAGE = 'HANDLE_INCOMING_MESSAGE';
export const HANDLE_READ_MESSAGE_CALLBACK = "HANDLE_READ_MESSAGE_CALLBACK";
export const HANDLE_RECEIVER_READ_MESSAGE = "HANDLE_RECEIVER_READ_MESSAGE";
export const HANDLE_MESSAGE_EDIT = "HANDLE_MESSAGE_EDIT";
export const HANDLE_MESSAGE_REMOVE = "HANDLE_MESSAGE_REMOVE";
export const HANDLE_STATUS_CHANGE = "HANDLE_STATUS_CHANGE";

// Get conversations list
export function initiateClientConversation(data, userId, callback) {
  return {
    type: INITIATE_CONVERSATION,
    payload : {data, userId, callback},
  };
}

// Get conversations list
export function conversationList(data, callback) {
  return {
    type: GET_CONVERSATION_LIST,
    payload : {data, callback},
  };
}
// Get converstation message history
export function conversationMessageHistory(data, conversationId, lastMessageId, callback) {
    return {
      type: GET_CONVERSATION_MESSAGE_HISOTRY,
      payload : {data, conversationId, lastMessageId, callback},
    };
  }
  
// send message to client
export function sendMessageToClient(data, callback) {
  return {
    type: SEND_MESSAGE,
    payload : {data, callback},
  };
}

// Update message status
export function updateMessageStatus(data, status, callback) {
  return {
    type: UPDATE_MESSAGE_STATUS,
    payload : {data, status, callback},
  };
}

// handle incoming message
export function handleIncomingMessage(data, callback) {
  return {
    type: HANDLE_INCOMING_MESSAGE,
    payload : {data, callback},
  };
}

// handle msg read callback
export function handleReadMessageCallback(data, callback) {
  return {
    type: HANDLE_READ_MESSAGE_CALLBACK,
    payload : {data, callback},
  };
}

// handle message read by receiver
export function handleReceiverReadMessage(data, callback) {
  return {
    type: HANDLE_RECEIVER_READ_MESSAGE,
    payload : {data, callback},
  };
}

// handle edit message
export function handleMessageEdit(data, callback) {
  return {
    type: HANDLE_MESSAGE_EDIT,
    payload : {data, callback},
  };
}

// handle remove message
export function handleMessageRemove(data, callback) {
  return {
    type: HANDLE_MESSAGE_REMOVE,
    payload : {data, callback},
  };
}

// handle status change
export function handleStatusChange(data, callback) {
  return {
    type: HANDLE_STATUS_CHANGE,
    payload : {data, callback},
  };
}